import * as R from 'ramda'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { createAction } from 'redux-actions'
import { dispatch, getState } from '$setup/redux'

interface AudioPlayerState {
  roomId?: string
  iid?: number
}

const initialState: AudioPlayerState = {}

// reducer
const SET_AUDIO_PLAYER_DATA = 'SET_AUDIO_PLAYER_DATA'
const setAudioPlayerData = createAction(SET_AUDIO_PLAYER_DATA)
const dispatchSetAudioPlayerData = (data: Partial<AudioPlayerState>) =>
  dispatch(setAudioPlayerData(data))

// reducers
const reducers = {
  [SET_AUDIO_PLAYER_DATA]: R.mergeRight,
}

export const audioPlayerStorage = {
  setData: ({ roomId, iid }: { roomId: string; iid: number }) =>
    dispatchSetAudioPlayerData({ roomId, iid }),
  getData: () => getState().main.audioPlayer as AudioPlayerState,
}

export const audioPlayerReducer = (
  state = initialState,
  {
    type,
    payload,
  }: { type: keyof typeof reducers; payload: Partial<AudioPlayerState> },
) => (reducers[type] ? reducers[type](state, payload) : state)
